<template>
    <div class='me-main'>
        <cell-card>
            <template #default>
                <van-cell>
                     <template #title>
                        <van-row type='flex'  align='center'>
                            <van-col>
                                <van-image
                                    round
                                    width="4rem"
                                    height="4rem"
                                    fit="cover"
                                    :src="avatar"
                                />
                            </van-col>
                            <van-col>
                                <span class="me-main__header-nickname">{{nickname}}</span>
                            </van-col>
                        </van-row>
                        
                    </template>
                </van-cell>
            </template>
        </cell-card>
        <cell-card
            :is-link="true"
            to="/order-list?orderState=ALL"
            value="全部订单"
            title="我的订单"
            class='me-main__order-wrapper'
        >
            <template #default>
                <van-grid :column-num="4">
                    <van-grid-item icon="pending-payment" text='待支付' to="/order-list?orderState=TO_PAY"/>
                    <van-grid-item icon='tosend' text='待发货' to="/order-list?orderState=TO_SEND"/>
                    <van-grid-item icon='sign' text='待收货' to="/order-list?orderState=TO_RECEIVE"/>
                    <van-grid-item icon='after-sale' text='售后' to="/order-list?orderState=AFTER_SALE"/>
                </van-grid>
            </template>
        </cell-card>

        <cell-card
            title="基础信息"
            :right-icon="(!wechatNo || !phone) ? 'edit' : ''"
            :onClick="onWechatBasicInfoClick"
        >
            <template #default>
                <van-cell title='手机号' :value='phone ? phone : "未填写"'></van-cell> 
                <van-cell title='微信账号' :value='wechatNo ? wechatNo : "未填写"'></van-cell>
            </template>
        </cell-card>
        <cell-card
            title="支付宝信息"
            :right-icon="(!alipayAccount || !alipayRealName) ? 'edit' : ''"
            :onClick="onAlipayEditClick"
        >
            <template #default>
                <van-cell title='账户姓名' :value='alipayRealName ? alipayRealName : "未填写"'/>
                <van-cell title='收款账户' :value='alipayAccount ? alipayAccount : "未填写"'></van-cell>
            </template>
        </cell-card>
        <!-- 我的钱包 -->
        <!-- <cell-card
            :is-link="false"
            title="我的钱包"
            class='me-main__wallet-wrapper'
        >
            <template #default>
                <van-grid :column-num="4">
                    <van-grid-item text='优惠券' to="/coupon-list">
                        <template #icon>
                            <van-icon :name='require("../assets/coupon-gradient.svg")'/>
                        </template>
                    </van-grid-item>
                </van-grid>
                
            </template>
        </cell-card> -->
        <!-- 我是有底线的 -->
        <van-divider
            class='me__bottom-line'
        >
            我是有底线的
        </van-divider>
    </div>    
</template>

<script>
import {Cell, CellGroup, Image, Col, Row, Icon, Grid, GridItem, Divider} from 'vant';
import CellCard from '@/components/CellCard.vue';
import request from '@/utils/request.js';
import qs from 'qs';

export default {
    name: 'Me',
    components: {
        [Cell.name]: Cell,
        [CellGroup.name]: CellGroup,
        [CellCard.name]: CellCard,
        [Image.name]: Image,
        [Col.name]: Col,
        [Row.name]: Row,
        [Icon.name]: Icon,
        [Grid.name]: Grid,
        [GridItem.name]: GridItem,
        [Divider.name]: Divider
    },
    data() {
        return {
            nickname: '',
            avatar: undefined,
            phone: undefined,
            wechatNo: undefined,
            alipayAccount: undefined,
            alipayRealName: undefined
        };
    },
    computed: {
        // balanceYuan: function() {
        //     return `¥${this.balance / 100}`;
        // },
        // withdrewBalanceYuan: function() {
        //     return `¥${this.withdrewBalance / 100}`;
        // }
    },
    async mounted() {
        this.loadCurrentUser();
    },
    methods: {
        async loadCurrentUser() {
            const {response, data} = await request.get('/user/currentUser');
            if (response.ok) {
                this.nickname = data.nickname;
                this.avatar = data.avatar;
                this.alipayAccount = data.alipayAccount;
                this.alipayRealName = data.alipayRealName;
                this.phone = data.phone;
                this.wechatNo = data.wechatNo;
            }
        },
        onAlipayEditClick() {
            if (this.alipayAccount && this.alipayRealName) {
                return;
            }
            const queryStr = qs.stringify({
                alipayAccount: this.alipayAccount,
                alipayRealName: this.alipayRealName,
                type: 'alipay'
            });
            this.$router.push(`/form?${queryStr}`);
        },
        onWechatBasicInfoClick() {
            if (this.wechatNo && this.phone) {
                return;
            }
            const queryStr = qs.stringify({
                phone: this.phone,
                nickname: this.nickname,
                wechatNo: this.wechatNo,
                type: 'basic-info'
            });
            this.$router.push(`/form?${queryStr}`);
        }
    }
}
</script>

<style lang="less">
@import '@/style/base.less';
.me-main {
    
    background-color: @color-background;

    &__header-nickname {
        padding-left: 16px;
        color: @font-color-title;
        font-size: @font-size-title;
    }
}

.me-main__order-wrapper, .me-main__wallet-wrapper {
    .van-hairline::after {
        border: none;
    }
    .van-hairline--top::after {
        border: none;
    }
}

.me-main__wallet-wrapper {
    .van-icon {
        background-image: linear-gradient(to right, #ff6034, #ee0a24);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }
}

.van-grid-item__icon-wrapper {
    .van-icon {
        font-size: 28px;
    }
}

</style>